import { render } from "./FlexTable.vue?vue&type=template&id=29402b1e&scoped=true"
import script from "./FlexTable.vue?vue&type=script&lang=js"
export * from "./FlexTable.vue?vue&type=script&lang=js"

import "./FlexTable.vue?vue&type=style&index=0&id=29402b1e&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\52618\\Documentos\\TheGoodMark\\Sistemas\\RHTGM\\orangehrm-5.9\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29402b1e"]])

export default __exports__